import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { AutoPlayData, AutoPlaySliderOptions } from "../../../Data/BonusUi/Carousel";
import { dynamicImage, dynamicNumber } from "../../../Utils";
import { Image } from "../../../AbstractElements";
import { AutoPlayVariants } from "../../../Constants/Constants";
import Slider from "react-slick";

const AutoPlayVariant = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={AutoPlayVariants} span={AutoPlayData} />
        <CardBody className="custom-padding-slider">
          <Slider {...AutoPlaySliderOptions}>
            {dynamicNumber(11).map((item, index) => (
              <div className="item px-1" key={index}>
                <Image src={dynamicImage(`slider/${item}.jpg`)} alt="Drawing-room" className="img-fluid rounded" />
              </div>
            ))}
          </Slider>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AutoPlayVariant;
